export const EmergencyLinks = (props) => {
  const { emergency_links } = props
  return (
    <div class="emergency emergency-links">
      <h3>{props.title}</h3>
      {emergency_links.map((link) => (
        <EmergencyLink key={link.url} {...link} />
      ))}
    </div>
  )
}

export const EmergencyLink = (props) => {
  const external = props.url.indexOf("http") === 0
  return (
    <a
      key={props.url}
      class={`emergency emergency-link ${props.class ? props.class : ""}`}
      href={props.url}
      target={external ? "_blank" : ""}
      rel={external ? "noopener noreferrer" : ""}
    >
      {props.linktext}
    </a>
  )
}
